import { useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { detectInAppBrowser } from "./Util";

export default function InAppBrowserBanner() {
  const [dismissed, setDismissed] = useState(false);

  // Detect which platform (returns undefined if not in an in-app browser)
  const platform = detectInAppBrowser();

  // Only show if user is in an in-app browser and hasn't dismissed
  if (!platform || dismissed) {
    return null;
  }

  const handleOpenInBrowser = () => {
    // Copy current URL to clipboard as a fallback
    const url = window.location.href;

    // Try to use the Share API if available (works on iOS)
    if (navigator.share) {
      navigator.share({
        url: url,
        title: document.title
      }).catch((err) => {
        // User cancelled or error occurred, just dismiss
        console.log('Share cancelled:', err);
      });
    } else {
      // Fallback: try to copy to clipboard
      navigator.clipboard?.writeText(url).then(() => {
        alert('Link copied to clipboard! Please paste it in Safari or Chrome.');
      }).catch(() => {
        alert('Please copy this link and open it in Safari or Chrome:\n\n' + url);
      });
    }
  };

  return (
    <div className="bg-yellow-50 border-b border-yellow-200">
      <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between flex-wrap">
          <div className="w-0 flex-1 flex items-center">
            <span className="flex p-2 rounded-lg bg-yellow-400">
              <svg
                className="h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </span>
            <p className="ml-3 font-medium text-yellow-800">
              <span className="md:hidden">For the best experience, open this page in your browser.</span>
              <span className="hidden md:inline">
                For the best experience, please open this page in Safari or Chrome instead of {platform}'s browser.
              </span>
            </p>
          </div>
          <div className="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
            <button
              onClick={handleOpenInBrowser}
              className="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-yellow-800 bg-yellow-100 hover:bg-yellow-200"
            >
              Open in Browser
            </button>
          </div>
          <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
            <button
              type="button"
              onClick={() => setDismissed(true)}
              className="-mr-1 flex p-2 rounded-md hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-white"
            >
              <span className="sr-only">Dismiss</span>
              <XMarkIcon className="h-5 w-5 text-yellow-800" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
